import React from "react";
import CreateCluster from "../sections/CreateCluster";

const ClusterWizard = () => {

    return (
        <CreateCluster/>
    );
}

export default ClusterWizard;